// src/features/attachment/format.ts
// Pure formatting helpers for the Attachment Manager — no React imports.

export function fmtDateTime(value: string | undefined, locale = 'en'): string {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString(locale, {
      year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return value;
  }
}

export function errMessage(e: unknown, fallback: string): string {
  if (e instanceof Error && e.message) return e.message;
  return fallback;
}
